import { createAction } from '@reduxjs/toolkit';

export const clearFreebets = createAction('freeBets/clearFreebets');
